function getListValue() { 
      var selectedOption, st;
      selectedOption = document.getElementById("SortBy").selectedIndex;
      st=document.getElementById("SortBy").options[selectedOption].value

       // window.location = st;
      //document.getElementById("myTextBoxResult").value=st;
      }

      function collectionTags() {
      var selectedOption, col;
      selectedOption = document.getElementById("pro-filter").selectedIndex;
      col=document.getElementById("pro-filter").options[selectedOption].value

       window.location = col;
      //document.getElementById("myTextBoxResult").value=st;
      }

       


      var x, i, j, l, ll, selElmnt, a, b, c,d;
      /*look for any elements with the class "custom-select":*/
      x = document.getElementsByClassName("custom-select");

      l = x.length;
      for (i = 0; i < l; i++) {
        
        selElmnt = x[i].getElementsByTagName("select")[0];
        ll = selElmnt.length;
        /*for each element, create a new DIV that will act as the selected item:*/
        a = document.createElement("DIV");
        a.setAttribute("class", "select-selected");
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);
        /*for each element, create a new DIV that will contain the option list:*/
        b = document.createElement("DIV");
        b.setAttribute("class", "select-items select-hide select" + i);
        for (j = 1; j < ll; j++) {
          /*for each option in the original select element,
          create a new DIV that will act as an option item:*/
          c = document.createElement("DIV");
          c.innerHTML = selElmnt.options[j].innerHTML;
          c.addEventListener("click", function(e) {
         
              /*when an item is clicked, update the original select box,
              and the selected item:*/
              var y, i, k, s, h, sl, yl;
              s = this.parentNode.parentNode.getElementsByTagName("select")[0];
              sl = s.length;
              h = this.parentNode.previousSibling;
              for (i = 0; i < sl; i++) {
                if (s.options[i].innerHTML == this.innerHTML) {
                  s.selectedIndex = i;
                  h.innerHTML = this.innerHTML;
                  
                  y = this.parentNode.getElementsByClassName("same-as-selected");
                  yl = y.length;
                  for (k = 0; k < yl; k++) {
                    y[k].removeAttribute("class");
                  }
                  this.setAttribute("class", "same-as-selected");
                  console.log("ssf");
                  // var evt = document.createEvent("HTMLEvents");
                  // evt.initEvent("change", false, true);
                  s.dispatchEvent(new Event('change'));
                  break;
                }
              }
              h.click();
           
            // getListValue();
            // collectionTags();
             
          });
          b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener("click", function(e) {
            /*when the select box is clicked, close any other select boxes,
            and open/close the current select box:*/
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle("select-hide");
            this.classList.toggle("select-arrow-active");
          
          });
       
      }
      function closeAllSelect(elmnt) {
        /*a function that will close all select boxes in the document,
        except the current select box:*/
        var x, y, i, xl, yl, arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        xl = x.length;
        yl = y.length;
        for (i = 0; i < yl; i++) {
          if (elmnt == y[i]) {
            arrNo.push(i)
          } else {
            y[i].classList.remove("select-arrow-active");
          }
        }
        for (i = 0; i < xl; i++) {
          if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
          }
        }
      }

         
      /*if the user clicks anywhere outside the select box,
      then close all select boxes:*/
      document.addEventListener("click", closeAllSelect);



      var sortDrop = document.getElementsByClassName("select1");
      function displayDate() {
       var selectedOption, col;
      selectedOption = document.getElementById("pro-filter").selectedIndex;
      col=document.getElementById("pro-filter").options[selectedOption].value
        
        window.location = col;
         
      }
      for (var i = 0; i < sortDrop.length; i++) {
          sortDrop[i].addEventListener('click', displayDate, false);
      }
      document.querySelector("#SortBy").addEventListener('change',(event) => {
        console.log("sdfds");
        var FacetFiltersFormNew = new FacetFiltersForm();
        FacetFiltersFormNew.onSubmitHandler(event);
      });

      document.querySelector("#SortBy-mobile").addEventListener('change',(event) => {
        var FacetFiltersFormNew = new FacetFiltersForm();
        FacetFiltersFormNew.onSubmitHandler(event);
      });
      var allRadios = document.querySelectorAll('form input[type=radio]');
      if(allRadios)
      {
        allRadios.forEach((element) => {
          element.addEventListener('change',(event) => {
            var FacetFiltersFormNew = new FacetFiltersForm();
            FacetFiltersFormNew.onSubmitHandler(event);
          });
        });  
      }
      var rangeInput = document.querySelectorAll(".range-slider input");
      if(rangeInput)
      {
        rangeInput.forEach((input) => {
            input.addEventListener("change", (event) => {
              var FacetFiltersFormNew = new FacetFiltersForm();
              FacetFiltersFormNew.onSubmitHandler(event);    
            });
        });
      }